import { dbVersion } from '../../constants';

export default {
  title: 'customFieldValue schema',
  version: dbVersion,
  keyCompression: true,
  primaryKey: 'uuid',
  type: 'object',
  required: ['uuid', 'customFieldUuid', 'contactUuid', 'value', 'createdAt', 'updatedAt'],
  properties: {
    uuid: {
      type: 'string',
      maxLength: 100,
    },
    customFieldUuid: {
      type: 'string',
    },
    contactUuid: {
      type: 'string',
    },
    value: {
      type: 'string',
    },
    createdAt: {
      type: ['number', 'null'],
    },
    updatedAt: {
      type: ['number', 'null'],
    },
    workspaceId: {
      type: 'string',
    },
  },
};
